/* eslint-disable */ 
import { URL } from '../../../config'
import { getRequest } from '../../../utils/functions/httpRequest'

export const getTeamPlayersBySeason = function (seasonId, teamId) {
  const endpoint = `/${seasonId}/${teamId}/teamplayersBySeason`;
  const rankingURL = `${URL.ranking}${endpoint}`;
  return getRequest(rankingURL);
} 


// WEBPACK FOOTER //
// ./src/components/pages/api/getTeamPlayersBySeason.js